import { Button, Col, Modal, Row, Space, Typography } from "antd";
import {
  birthday2Age,
  formatToCurrencyType,
  getDateStringLocaleDetail,
} from "helper/common";
import React, { useEffect, useRef, useState } from "react";
import dayjs from "dayjs";
import { gioiTinhOptions } from "assets/constants/select-catagory-options";
import moment from "moment";
import ReactToPrint from "react-to-print";
import "./ModalPrintPTT.scss";
import BoxBHYT from "./BoxBHYT/BoxBHYT";
import { useAppSelector } from "redux/hooks";
import { payService } from "api";
import { Notification } from "components/common";

const { Text } = Typography;

const ModalPrintPTT = (props) => {
  const { isShowModal, handleOk, handleCancel } = props;
  console.log("🚀 ~ ModalPrintPTT ~ isShowModal:", isShowModal);
  const printRef = useRef<any>();
  const [thongTinIn, setThongTinIn] = useState<any>(null);
  const [detailMoney, setDetailMoney] = useState<any>(null);
  console.log("🚀 ~ ModalPrintPTT ~ detailMoney:", detailMoney);
  const idLanKham = useAppSelector((state) => state.reduxCommon.id);
  const listId = useAppSelector((state) => state.reduxCommon.listIdCommon);
  const valueMienGiam = useAppSelector(
    (state) => state.reduxCommon.valueMienGiam
  );

  useEffect(() => {
    if (isShowModal) {
      getData();
      getDataInfo();
    } else setDetailMoney(null);
  }, [isShowModal]);

  const getData = async () => {
    let value;
    if (valueMienGiam) {
      value = valueMienGiam;
    } else {
      value = 0;
    }
    try {
      let response = await payService.getDataPrintPTT(listId, 0).then((res) => {
        // console.log('data in phieu thu tien', res);
        setDetailMoney(res.data.data);
      });
    } catch (err) {
      // Notification("error", "Đã có lỗi xảy ra khi lấy dữ liệu in phiếu");
    }
  };

  const getDataInfo = async () => {
    try {
      let response = await payService
        .getDataPayPrintPerson(idLanKham)
        .then((res) => {
          // console.log('data in', res);
          setThongTinIn(res.data.data);
        });
    } catch (err) {}
  };

  const capitalizeFirstLetter = (str) => {
    if (!str) return "";
    if (str.charAt(0) == " ") {
      return "Không " + str.slice(1);
    } else {
      return str.charAt(0).toUpperCase() + str.slice(1);
    }
  };

  const getTodayString = () => {
    // const today = moment().format();
    const day = moment().format("DD");
    const month = moment().format("MM");
    const year = moment().format("YYYY");
    const time = moment().format("HH:mm A");
    return `Ngày ${day} tháng ${month} năm ${year}`;
  };

  const getToday = () => {
    // const today = moment().format();
    const day = moment().format("DD");
    const month = moment().format("MM");
    const year = moment().format("YYYY");
    const time = moment().format("HH:mm A");
    return `${day}/${month}/${year} ${time}`;
  };

  const onPrint = async () => {
    window.print();
  };

  return (
    <Modal
      centered
      open={isShowModal}
      onCancel={handleCancel}
      closable={false}
      footer={null}
      width={1000}
      className="modal-custom-print-PTT"
    >
      <div className="print-phieu-thu-tien">
        <div ref={printRef} className="print">
          <div>
            <Row justify={"space-between"} style={{ paddingTop: "10px" }}>
              <Col span={18}>
                <Space direction="vertical" size={60}>
                  <Row>
                    <Row justify={"center"}>
                      <Typography.Text strong>BỘ Y TẾ</Typography.Text>
                    </Row>
                    <Row justify={"center"}>
                      <Typography.Text strong>
                        BỆNH VIỆN CHUYÊN KHOA MẮT ALINA
                      </Typography.Text>
                    </Row>
                  </Row>
                </Space>
              </Col>
              <Col span={6}>
                <Space direction="vertical" size={60}>
                  <Row>
                    <Row justify={"start"}>
                      <Typography.Text strong>
                        Số phiếu: {detailMoney?.soPhieuThu}
                      </Typography.Text>
                    </Row>
                  </Row>
                </Space>
              </Col>
            </Row>
            {/* <HeaderPrintForm /> */}
            <Row>
              <Row justify={"center"}>
                <Typography.Title
                  style={{
                    fontWeight: "700",
                    fontSize: "20px",
                    margin: 0,
                  }}
                >
                  PHIẾU THU TIỀN
                </Typography.Title>
              </Row>
              <Row style={{ paddingTop: "10px" }}>
                <Row>
                  <Col span={10}>
                    <Typography.Text>
                      Họ và tên: {detailMoney?.hoTen?.toUpperCase()}
                    </Typography.Text>
                  </Col>
                  <Col span={7}>
                    Tuổi:{" "}
                    {detailMoney?.ngaySinh
                      ? birthday2Age(detailMoney?.ngaySinh)
                      : ""}{" "}
                  </Col>
                  <Col span={7}>
                    <Typography.Text>
                      Giới tính:{" "}
                      {
                        gioiTinhOptions.find(
                          (it) => it.value === detailMoney?.gioiTinh
                        )?.label
                      }
                    </Typography.Text>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Typography.Text>
                      Địa chỉ: &nbsp;
                      <Typography.Text>{detailMoney?.diaChi}</Typography.Text>
                    </Typography.Text>
                  </Col>
                </Row>
                <Row>
                  <Col span={10}>
                    <Typography.Text>Đối tượng: Vượt trần;</Typography.Text>
                  </Col>
                  <Col span={14}>
                    <Typography.Text
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      Thẻ BHYT: &nbsp;
                      <BoxBHYT code={detailMoney?.soTheBaoHiemYTe ?? ""} />
                      {/* <Typography.Text>
                        {thongTinIn?.soTheBaoHiemYTe}
                      </Typography.Text> */}
                    </Typography.Text>
                  </Col>
                </Row>
                <Row>
                  <Col span={10}>
                    <Typography.Text>
                      Tổng tiền: &nbsp;
                      <Typography.Text strong>
                        {formatToCurrencyType(detailMoney?.tongTien)}
                      </Typography.Text>
                    </Typography.Text>
                  </Col>
                  <Col span={12}>
                    <Typography.Text>
                      Tổng tiền đã tạm ứng: &nbsp;
                      <Typography.Text strong>
                        {formatToCurrencyType(detailMoney?.tongTienTamUng)}
                      </Typography.Text>
                    </Typography.Text>
                  </Col>
                </Row>
                <Row>
                  <Col span={10}>
                    <Typography.Text>
                      Tổng tiền phải trả: &nbsp;
                      <Typography.Text strong>
                        {formatToCurrencyType(detailMoney?.tongTienPhaiTra)}
                      </Typography.Text>
                    </Typography.Text>
                  </Col>
                  <Col span={6}>
                    <Typography.Text>
                      Tổng tiền hoàn trả: &nbsp;
                      <Typography.Text strong>
                        {formatToCurrencyType(detailMoney?.tongTienHoanTra)}
                      </Typography.Text>
                    </Typography.Text>
                  </Col>
                </Row>
                <Row>
                  <Typography.Text>
                    Tổng tiền miễn giảm: &nbsp;
                    <Typography.Text>
                      {formatToCurrencyType(detailMoney?.tongTienMienGiam)}
                    </Typography.Text>
                  </Typography.Text>
                </Row>
                <Row>
                  <Typography.Text>
                    Tổng tiền bằng chữ: &nbsp;
                    <Typography.Text>
                      {capitalizeFirstLetter(detailMoney?.tongTienChu)}
                    </Typography.Text>
                  </Typography.Text>
                </Row>
                <Row>
                  <Typography.Text>
                    Số tiền tạm ứng bằng chữ: &nbsp;
                    <Typography.Text>
                      {capitalizeFirstLetter(detailMoney?.tongTienTamUngChu)}
                    </Typography.Text>
                  </Typography.Text>
                </Row>
                <Row>
                  <Typography.Text>
                    Số tiền phải trả bằng chữ: &nbsp;
                    <Typography.Text>
                      {capitalizeFirstLetter(detailMoney?.tongTienPhaiTraChu)}
                    </Typography.Text>
                  </Typography.Text>
                </Row>
                <Row>
                  <Typography.Text>
                    Số tiền hoàn lại bằng chữ: &nbsp;
                    <Typography.Text>
                      {capitalizeFirstLetter(detailMoney?.tongTienHoanTraChu)}
                    </Typography.Text>
                  </Typography.Text>
                </Row>
                <Row>
                  <Typography.Text>
                    Tổng tiền miễn giảm bằng chữ: &nbsp;
                    <Typography.Text>
                      {capitalizeFirstLetter(detailMoney?.tongTienMienGiamChu)}
                    </Typography.Text>
                  </Typography.Text>
                </Row>
              </Row>
              <Row>
                <Row justify={"end"}>
                  <Typography.Text
                    className="date-sign"
                    italic
                    style={{ marginRight: "35px" }}
                  >
                    {getDateStringLocaleDetail(thongTinIn?.thoiGianThanhToan)}
                  </Typography.Text>
                </Row>
                <Row justify={"space-between"}>
                  <Col style={{ paddingLeft: "50px" }}>
                    <Row>
                      <Row justify={"center"}>
                        <Typography.Text strong>Người nhận</Typography.Text>
                      </Row>
                      <Row justify={"center"}>
                        <Typography.Text italic>
                          (Ký và ghi rõ họ tên)
                        </Typography.Text>
                      </Row>
                    </Row>
                  </Col>
                  <Col>
                    <Space direction="vertical" size={60}>
                      <Row>
                        <Row justify={"center"}>
                          <Typography.Text strong>
                            Người thu tiền
                          </Typography.Text>
                        </Row>
                        <Row justify={"center"}>
                          <Typography.Text italic>
                            (Ký và ghi rõ họ tên)
                          </Typography.Text>
                        </Row>
                      </Row>
                      <Row justify={"center"}>
                        <Typography.Text strong>
                          {thongTinIn?.tenThuNgan
                            ? thongTinIn?.tenThuNgan
                            : localStorage.getItem("fullName")}
                        </Typography.Text>
                      </Row>
                    </Space>
                  </Col>
                </Row>
                <Row></Row>
              </Row>
              <Row>
                <Col span={8}>
                  <Row justify={"space-between"}>
                    <Col>
                      <Row>
                        <Typography.Text
                          strong
                          italic
                          style={{ fontSize: "10px" }}
                        >
                          Ngày in: {getToday()}
                        </Typography.Text>
                      </Row>
                    </Col>
                    <Col>
                      <Row>
                        <Typography.Text
                          strong
                          italic
                          style={{ fontSize: "10px" }}
                        >
                          Người in:{" "}
                          {thongTinIn?.tenThuNgan
                            ? thongTinIn?.tenThuNgan
                            : localStorage.getItem("fullName")}
                        </Typography.Text>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Row>
          </div>
        </div>
        <Row justify={"end"} style={{ padding: "12px", gap: "4px" }}>
          <Space direction="horizontal">
            <Button danger type="primary" onClick={handleCancel}>
              HỦY
            </Button>
            <ReactToPrint
              trigger={() => {
                return (
                  <Button type="primary" onClick={onPrint}>
                    IN
                  </Button>
                );
              }}
              content={() => printRef.current}
              onAfterPrint={handleCancel}
              bodyClass="print-phieu-thu-tien"
            />
          </Space>
        </Row>
      </div>
    </Modal>
  );
};

export default ModalPrintPTT;
